import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickArchive,
    onClickDelete,
    onClickEdit,
    onClickView,
    watchRulesChildren,
} from "../../../../../utils/form";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonDelete,
    createButtonEdit,
    createButtonView,
} from "../../../../../utils/button";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";
import { createAppPageHeaderTop } from "../../../../../utils/page";
import { has } from "../../../../../utils/menu-context";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { Col, notification, Row } from "ant-design-vue";
import store from "../../../../../store";
import { createLoading } from "../../../../../utils/loading";
//import moment from "moment";
import {
    createFieldChangeLicense,
    createFieldChangeRequestLicense,
    createFieldRefOriginalOwner,
    // createFieldRefOriginalRequester
} from "./change-license.section";
import {
    createFieldFisheryOfficerConsider,
    createFieldLawyerConsider,
    createFieldArgueLawyerConsider,
    createFieldDofCenterConsider,
    createFieldDirectorConsider,
    createFieldRDConsider,
    callLicenseRequestStatus,
    callRequestType,
    callAddressType,
    callNationality,
    createFieldAppealRequest,
    createFieldRequestDetail,
    createFieldRequester,
    createLogFishingToolRequests,
    callPreviewVesselRequestAttachment,
    callFishingArea
} from "../license/request-license.section";
import { createForm as requestLicenseForm /*, onClickOpenModalOtp, onClickRequest*/ } from "../license/request-license.logic";
import { createForm as createFormAddress } from "../../../../../components/address/address.logic";

import { createConditionForm } from "./change-license.condition";
import { state, createWhereFor } from "../request.logic";
import { toRaw } from "vue";
import {
    required,
    requiredWhen,
    validateError,
    thPid,
    requiredTrue,
    thPidFirstCharacter
} from "../../../../../utils/validate";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { openModal as openModalOtp } from "../../../../../components/verify-otp/verify-otp.logic";
import { openModalForm as openModalFormConfirmRequest } from "../../modal/confirm-request.logic";
import { createButtonDropdown } from "../../../../../utils/dropdown";
import { createReportItems } from "../request.report";
import { callReceiverDepartment } from "../../../license/license.section";
import { scrollToQuerySelector } from "../../../../../utils/scroll";

export const callChangeRequestAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_CHANGE_REQUEST_ATTACHMENT", value: searchQuery, options: { sort: [{ name: "key", type: "asc" }] } });

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/licenseRequest";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSaveAll = ({ form }) => store.dispatch(`${actionPrefix}/saveAll`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callRequestLicense = ({ form }) => store.dispatch(`${actionPrefix}/requestLicense`, { data: form });

//todo: request
export const onClickRequest = ({ props, data, refs, formParams, successText, otp, isSendRequest, ignoreValidate }) => {
    const { viewOnly, routerPrefix } = props;
    if (ignoreValidate) {
        setIsLoadingApp(true);
        return callRequestLicense({ form: { licenseRequest: { ...data.useForm.modelRef, ...formParams }, otp, isSendRequest } })
            .finally(() => setIsLoadingApp(false))
            .then((record) => {
                if (successText) notification["success"]({ message: successText });
                if (viewOnly) initForm({ props, data, refs });
                else onClickView({ record, routerPrefix, props });
            });
    } else {
        return validate({ props, data, refs }).then(() => {
            setIsLoadingApp(true);
            return callRequestLicense({ form: { licenseRequest: { ...data.useForm.modelRef, ...formParams }, otp, isSendRequest } })
                .finally(() => setIsLoadingApp(false))
                .then((record) => {
                    if (successText) notification["success"]({ message: successText });
                    if (viewOnly) initForm({ props, data, refs });
                    else onClickView({ record, routerPrefix, props });
                });
        });
    }
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**", "refRequester.**", "refPrintStatus.**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "addresses",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refId", type: "UUID", operator: "=", value: id }],
                },
                {
                    name: "refVesselRequest.vesselOwnerRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "refVesselRequest.attachmentVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refVesselRequest.attachmentPositionVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refVesselRequest.attachmentHeadVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refVesselRequest.attachmentFullVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "fishingToolRequests",
                    select: ["**", "refOriginal.**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "fishingToolDeclarations",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "licenseRequestInspections",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "refInspectionTopic.seq", type: "ASC" }],
                    children: [
                        {
                            name: "children",
                            select: ["*", "refLicenseRequest.*", "refInspectionTopic.*", "refParent.*"],
                            page: 0,
                            size: 1000000,
                        },
                    ],
                },
                {
                    name: "feeStatements",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "attachmentFeeSlips",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "attachmentDutySlips",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: []
                },
                {
                    name: "attachmentReviewRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "ReviewRequest" },
                    ],
                },
                {
                    name: "attachmentRDs",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "RD" },
                    ],
                },
                {
                    name: "attachmentLawyers",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "Lawyer" },
                    ],
                },
                {
                    name: "attachmentArgueLawyers",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "ArgueLawyer" },
                    ],
                },
                {
                    name: "attachmentDofCenters",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "DofCenter" },
                    ],
                },
                {
                    name: "attachmentDirectors",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "DofCenter" },
                    ],
                },
                {
                    name: "attachmentCancelRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "refId", type: "UUID", operator: "=", value: id },
                        { name: "group", type: "String", operator: "=", value: "CancelLicenseRequestAttachment" },
                    ],
                },
            ],
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [
                { name: "fishingToolRequests", select: ["*", "refFishingTool.value"], page: 0, size: 1000000 },
                { name: "fishingToolDeclarations",
                    select: ["*", "refFishingTool.value"],
                    page: 0, size: 1000000 },
                {
                    name: "refVesselRequest.vesselOwnerRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
            ],
        };
    }
};

export const createSearchOneCriteriaOriginal = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: ["id", "refOriginal.*", "refOriginal.refFishingArea.*", "refOriginal.refVesselRequest.*",
                "refOriginal.refOwnerTitle",
                "refOriginal.refOwnerCompanyType",
                "refOriginal.refOwnerPersonType",
                "refOriginal.refOwnerNationality",
            ],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "refOriginal.refVesselRequest.vesselOwnerRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "refOriginal.refVesselRequest.attachmentVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refOriginal.refVesselRequest.attachmentPositionVesselIdentities",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refOriginal.refVesselRequest.attachmentHeadVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refOriginal.refVesselRequest.attachmentFullVessels",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "refOriginal.fishingToolRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "refOriginal.fishingToolDeclarations",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "refOriginal.addresses",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refId", type: "UUID", operator: "=", value: id }],
                },
                {
                    name: "refOriginal.addressOwners",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refId", type: "UUID", operator: "=", value: id }],
                },
            ],
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [],
        };
    }
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.refRequestType?.value} (${modelRef.refStatus?.value})` : `${i18n.global.t("button.create")} ${modelRef.refRequestType?.value}`;
};

export const createForm = () => {
    return {
        refRequestType: null,
        refChangeLicenseObjective: null,
        reasonReplace: null,
        dockReplaceShip: null,
        refReplaceShipRemark: null,
        otherRemark: null,
        refChangeFishingAreaRemark: null,
        movingShipMode: null,
        ...requestLicenseForm(),
    };
};

export const validate = ({ props, data, refs }) => {
    const { menuContext } = props;
    const rulesTop = createRulesTop({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules2 = createRulesTab2({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });
    const rules4 = createRulesTab4({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesTop))
        .then(() => {
            tabKey = "Vessel";
            return data.useForm.validate(Object.keys(rules1));
        })
        .then(() => {
            tabKey = "VesselOwner";
            return data.useForm.validate(Object.keys(rules2));
        })
        .then(() => {
            tabKey = "FishingTool";
            return data.useForm.validate(Object.keys(rules3));
        })
        .then(() => {
            tabKey = "Attachment";
            return data.useForm.validate(Object.keys(rules4));
        })
        .catch((error) => {
            if (tabKey) {
                menuContext.tabKey = tabKey;
            }
            validateError({ error });
            throw error;
        });
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTop({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab2({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key }),
        ...createRulesTab4({ props, data, refs, key }),
    };
};

export const createRulesTop = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refReceiveDept`]: [required],
        [`${prefix}refOriginal`]: [required],
        [`${prefix}refChangeLicenseObjective`]: [required],

        // [`${prefix}refRequester`]: [required],
        [`${prefix}refRequesterPersonType`]: [required],
        [`${prefix}refRequesterCompanyType`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === "1" })],
        [`${prefix}requesterName`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === "1" })],
        [`${prefix}refRequesterTitle`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '2' })],
        [`${prefix}requesterFirstName`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '2' })],
        [`${prefix}requesterLastName`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '2' })],
        [`${prefix}requesterAge`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '2' })],
        [`${prefix}refRequesterNationality`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '2' })],
        [`${prefix}requesterEmail`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === '1' })],
        [`${prefix}requesterMobile`]: [required],
        [`${prefix}requesterShareholdingTh`]: [requiredWhen({ when: () => model.refRequesterPersonType?.key === "1" })],
        [`${prefix}requesterIdCard`]: [
            required,
            thPid,
            requiredWhen({
                when: () => model.refRequesterPersonType?.key != "1",
                requiredValidator: ({ rule, value }) => {
                    return thPidFirstCharacter.validator(rule, value);
                },
            }),
        ],
        [`${prefix}attorneyIdCard`]: [
            thPid,
            requiredWhen({
                when: () => model.isAttorney,
                requiredValidator: ({ rule, value }) => {
                    return thPidFirstCharacter.validator(rule, value);
                },
            }),
        ],
        [`${prefix}refAttorneyTitle`]: [requiredWhen({ when: () => model.isAttorney === true })],
        [`${prefix}attorneyFirstName`]: [requiredWhen({ when: () => model.isAttorney === true })],
        [`${prefix}attorneyLastName`]: [requiredWhen({ when: () => model.isAttorney === true })],
        [`${prefix}attorneyPhoneNumber`]: [requiredWhen({ when: () => model.isAttorney === true })],
        [`${prefix}refFishingArea`]: [required],

        //เงื่อนไขขอเปลี่ยนแปลงแต่ละวัตถุประสงค์
        [`${prefix}reasonReplace`]: [requiredWhen({ when: () => ["replaceBoat"].includes(model.refChangeLicenseObjective?.key) })],
        [`${prefix}dockReplaceShip`]: [requiredWhen({ when: () => ["replaceBoat"].includes(model.refChangeLicenseObjective?.key) })],
        [`${prefix}refReplaceShipRemark`]: [requiredWhen({ when: () => ["replaceBoat"].includes(model.refChangeLicenseObjective?.key) })],
        [`${prefix}refChangeFishingAreaRemark`]: [requiredWhen({ when: () => ["moveAshore"].includes(model.refChangeLicenseObjective?.key) })],
        [`${prefix}otherRemark`]: [
            requiredWhen({
                when: () =>
                    (["moveAshore"].includes(model.refChangeLicenseObjective?.key) && ["99"].includes(model.refChangeFishingAreaRemark?.key)) ||
                    (["replaceBoat"].includes(model.refChangeLicenseObjective?.key) && ["4", "2"].includes(model.refReplaceShipRemark?.key)),
            }),
        ],
        [`${prefix}movingShipMode`]: [requiredWhen({ when: () => ["moveAshore"].includes(model.refChangeLicenseObjective?.key) })],

        [`${prefix}totalThaiWorkers`]: [requiredWhen({ when: () => model.isThaiWorkers === true })],
        [`${prefix}thaiMaleWorkers`]: [requiredWhen({ when: () => model.isThaiWorkers === true })],
        [`${prefix}thaiFemaleWorkers`]: [requiredWhen({ when: () => model.isThaiWorkers === true })],
        [`${prefix}totalForeignWorkers`]: [requiredWhen({ when: () => model.isForeignWorkers === true })],
        [`${prefix}foreignMaleWorkers`]: [requiredWhen({ when: () => model.isForeignWorkers === true })],
        [`${prefix}foreignFemaleWorkers`]: [requiredWhen({ when: () => model.isForeignWorkers === true })],
        // [`${prefix}refFisheriesOfficer`]: [requiredWhen({ when: () => data.sendRequest })],
        // [`${prefix}refFisheriesOfficerStatus`]: [requiredWhen({ when: () =>  model.refStatus.key === "waitAcceptRequest" })],
        // [`${prefix}fisheriesOfficerRemark`]: [requiredWhen({ when: () =>  model.refFisheriesOfficerStatus?.key === "disagree" })],
        // [`${prefix}expireDateToEdit`]: [requiredWhen({ when: () =>  model.refFisheriesOfficerStatus?.key === "disagree" })],
        [`${prefix}refLawyerStatus`]: [requiredWhen({ when: () =>  model.refStatus?.key === "waitLawyerAudit" })],
        [`${prefix}lawyerRemark`]: [requiredWhen({ when: () => model.refLawyerStatus?.key === "disagree" })],
        [`${prefix}argueLawyerDate`]: [requiredWhen({ when: () => model.refLawyerStatus?.key === "disagree" })],
        [`${prefix}refArgueLawyerStatus`]: [requiredWhen({ when: () =>  model.refStatus?.key === "waitArgueLawyer" })],
        [`${prefix}argueLawyerRemark`]: [requiredWhen({ when: () => model.refArgueLawyerStatus?.key === "argue" })],
        [`${prefix}attachmentArgueLawyers`]: [requiredWhen({ when: () => model.refArgueLawyerStatus?.key === "argue" })],
        [`${prefix}refRdStatus`]: [requiredWhen({ when: () => model.refStatus?.key === "waitRDAudit" })],
        // [`${prefix}lawyerRemark`]: [required],
        // [`${prefix}refDofCenterStatus`]: [requiredWhen({ when: () =>  model.refStatus.key === "waitDofCenterAudit" })],
        // [`${prefix}dofCenterRemark`]: [required],
        // [`${prefix}refDirectorStatus`]: [requiredWhen({ when: () =>  model.refStatus.key === "waitApprove" })],
        // [`${prefix}directorRemark`]: [required],

        [`${prefix}refFisheriesOfficerStatus`]: [requiredWhen({ when: () => model.refStatus?.key === "waitAcceptRequest" })],
        [`${prefix}fisheriesOfficerRemark`]: [requiredWhen({ when: () => model.isFisheriesOfficerRemark })],
        [`${prefix}fisheriesOfficerRemark2`]: [requiredWhen({ when: () => model.isFisheriesOfficerRemark2 })],
        [`${prefix}expireDateToEdit`]: [requiredWhen({ when: () => model.refFisheriesOfficerStatus?.key === "disagree" })],
        // [`${prefix}refLawyerStatus`]: [requiredWhen({ when: () =>  model.refStatus?.key === "waitLawyerAudit" })],
        // [`${prefix}lawyerRemark`]: [requiredWhen({ when: () =>  model.refLawyerStatus?.key === "disagree" })],
        [`${prefix}refDofCenterStatus`]: [requiredWhen({ when: () => model.refStatus?.key === "waitDofCenterAudit" })],
        [`${prefix}dofCenterRemark`]: [requiredWhen({ when: () => model.refDofCenterStatus?.key === "disagree" })],
        [`${prefix}refDirectorStatus`]: [requiredWhen({ when: () => model.refStatus?.key === "waitApprove" })],
        [`${prefix}directorRemark`]: [requiredWhen({ when: () => model.refDirectorStatus?.key === "disagree" })],

        [`${prefix}isCancelRequest`]: [requiredWhen({ when: () => data.isCancelRequest })],
        [`${prefix}cancelRequestRemark`]: [requiredWhen({ when: () => model.isCancelRequest })],
        [`${prefix}attachmentCancelRequests`]: [requiredWhen({ when: () => model.isCancelRequest })],

        [`${prefix}refAppealRequestStatus`]: [requiredWhen({ when: () => model.isHaveAppealedRequest == true })],
        [`${prefix}appealRequestRemark`]: [requiredWhen({ when: () => model.refAppealRequestStatus?.key === "appeal" })],
        [`${prefix}attachmentAppealRequests`]: [requiredWhen({ when: () => model.refAppealRequestStatus?.key === "appeal" })],
    };
    model?.addresses?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}addresses.${index}.refAddressType`] = [required];
            rules[`${prefix}addresses.${index}.noTh`] = [required];
            rules[`${prefix}addresses.${index}.soiTh`] = [required];
            rules[`${prefix}addresses.${index}.roadTh`] = [required];
            rules[`${prefix}addresses.${index}.mooTh`] = [requiredWhen({ when: () => model?.addresses[index]?.refProvince?.code !== "10" })];
            rules[`${prefix}addresses.${index}.refProvince`] = [required];
            rules[`${prefix}addresses.${index}.refAmphur`] = [required];
            rules[`${prefix}addresses.${index}.refTambon`] = [required];
            rules[`${prefix}addresses.${index}.postCode`] = [required];
        }
    });
    return rules;
};

export const createRulesTab1 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refVesselRequest.code`]: [required],
        // [`${prefix}refVesselRequest.name`]: [required],
        // [`${prefix}refVesselRequest.tgross`]: [required],
        // [`${prefix}refVesselRequest.lbp`]: [required],
        // [`${prefix}refVesselRequest.loa`]: [required],
        // [`${prefix}refVesselRequest.deep`]: [required],
        // [`${prefix}refVesselRequest.breadth`]: [required],
        // [`${prefix}refVesselRequest.attachmentVesselIdentities.0.size`]: [required],
        // [`${prefix}refVesselRequest.attachmentPositionVesselIdentities.0.size`]: [required],
        // [`${prefix}refVesselRequest.attachmentHeadVessels.0.size`]: [required],
        // [`${prefix}refVesselRequest.attachmentFullVessels.0.size`]: [required],
    };


    model?.refVesselRequest?.attachmentVesselIdentities?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refVesselRequest.attachmentVesselIdentities.${index}.size`] = [requiredWhen({ when: () => /* data.isSendRequest && */ modelRef.refChangeLicenseObjective?.key == "replaceBoat" })];
        }
    });
    model?.refVesselRequest?.attachmentPositionVesselIdentities?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refVesselRequest.attachmentPositionVesselIdentities.${index}.size`] = [requiredWhen({ when: () => /* data.isSendRequest && */ modelRef.refChangeLicenseObjective?.key == "replaceBoat" })];
        }
    });
    model?.refVesselRequest?.attachmentHeadVessels?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refVesselRequest.attachmentHeadVessels.${index}.size`] = [requiredWhen({ when: () => /* data.isSendRequest && */ modelRef.refChangeLicenseObjective?.key == "replaceBoat" })];
        }
    });
    model?.refVesselRequest?.attachmentFullVessels?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refVesselRequest.attachmentFullVessels.${index}.size`] = [requiredWhen({ when: () => /* data.isSendRequest && */ modelRef.refChangeLicenseObjective?.key == "replaceBoat"})];
        }
    });

    return rules
};

export const createRulesTab2 = () => {
    const rules = {};
    return rules;
};

export const createRulesTab3 = () => {
    const rules = {};
    return rules;
};

export const createRulesTab4 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.attachments?.forEach((item, index) => {
        if (item.isDelete !== true && item?.attribute?.isRequiredAttachment === true) {
            rules[`${prefix}attachments.${index}.documentName`] = [required];
            rules[`${prefix}attachments.${index}.size`] = [
                requiredWhen({
                    when: () =>
                        model.attachments[index].attribute?.isRequiredAttachment ||
                        model.attachments[index].attribute?.documentNo
                        || (model.attachments[index].keyAttachment === "2" && model.refRequesterPersonType?.key === "1")
                        || (model.attachments[index].keyAttachment === "3" && model.isAttorney),
                }),
            ];
        }
       if (item.isDelete !== true && item?.attribute?.isRequiredVerify === true) {
            rules[`${prefix}attachments.${index}.isVerify`] = [
                requiredWhen({
                    when: () => ["waitAcceptRequest"].includes(model.refStatus?.key) && model.attachments[index].isReject != true,
                    requiredValidator: ({ value, rule }) => requiredTrue().validator(rule, value)
                })
            ]
            rules[`${prefix}attachments.${index}.isReject`] = [
                requiredWhen({
                    when: () => ["waitAcceptRequest"].includes(model.refStatus?.key) && model.attachments[index].isVerify != true,
                    requiredValidator: ({ value, rule }) => requiredTrue().validator(rule, value)
                })
            ]
        }
    });
    return rules;
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const colCenter = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    const canWaitFisheryOfficer = state.conditionAction.canWaitFisheryOfficer({ props, record: initialModel });
    const canConfirmResult = state.conditionAction.canConfirmResult({ props, record: initialModel });
    const canCancelRequest = state.conditionAction.canCancelRequest({ props, record: initialModel });
    const canArgueLawyer = state.conditionAction.canArgueLawyer({ props, record: initialModel });
    const canApproveCancelRequest = state.conditionAction.canApproveCancelRequest({ props, record: initialModel });
    const canAppealRequest = state.conditionAction.canAppealRequest({ props, record: initialModel });

    // if (id && has({ menuContext, key: "canCreate" })) {
    //     col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    // }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButton({
                text: `${i18n.global.t("button.save")} `,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    validate({ props, data, refs }).then(() => {
                        onClickRequest({
                            props: { ...props, form: null },
                            data,
                            refs,
                            formParams: {},
                            otp: null,
                            successText: [undefined, "draft"].includes(modelRef.refStatus?.key)
                                ? i18n.global.t("views.request.licenseRequest.saveDraftSuccess")
                                : i18n.global.t("views.request.licenseRequest.saveRequestSuccess"),
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
            })
        );
    }

    if (viewOnly && id && isActive) {
        colCenter.push(
            createButtonDropdown({
                text: i18n.global.t("button.print"),
                items: createReportItems({ props, modelRef, id }),
            })
        );
    }

    if (viewOnly && id && isActive && canWaitFisheryOfficer) {
        const statusWaitFisheryOfficer = data.statuses.find((status) => status.key === "waitAcceptRequest");
        col2.push(
            createButton({
                text: `${statusWaitFisheryOfficer?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitFisheryOfficer?.attribute?.btnClass}`,
                onClick: () => {
                    if (data.useForm?.modelRef?.fishingToolDeclarations.length > 0 && !data.useForm?.modelRef?.fishingToolDeclarations.map(d => d.isResult).some(Boolean)) {
                        notification["error"]({ message: i18n.global.t("error.v1LicenseRequestService.handleProcessRequestLicense.fishingToolDeclaration.null") });
                        data.tabKey = "FishingTool"
                        scrollToQuerySelector("#fishingToolDeclaration")
                        return ;
                    }
                    data.isSendRequest = true;
                    validate({ props, data, refs }).then(() => {
                        data.statusWaitFisheryOfficer = statusWaitFisheryOfficer;
                        if (modelRef.refRequestType?.attribute?.isRequireOtp && !modelRef.isOfficerCreate) {
                            onClickOpenModalOtp({
                                props,
                                data,
                                refs,
                            })
                        } else {

                            openModalFormConfirmRequest({
                                props,
                                data,
                                onOk: () => {
                                    onClickRequest({
                                        props,
                                        data,
                                        refs,
                                        formParams: {},
                                        otp: null,
                                        isSendRequest: data.isSendRequest,
                                        successText: i18n.global.t("views.request.licenseRequest.requestSuccess"),
                                    });
                                },
                            });
                        }
                    });
                },
            })
        );
    }

    if (viewOnly && id && isActive && canConfirmResult && (!has({ menuContext, key: "canActionAssignMe" }) || props.isRouteFromMyJob)) {
        const statusWaitLawyerAudit = data.statuses.find((status) => status.key === "waitLawyerAudit");
        col2.push(
            createButton({
                text: `${statusWaitLawyerAudit?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitLawyerAudit?.attribute?.btnClass}`,
                onClick: () => {
                    data.isSendRequest = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmRequest({
                            props,
                            data,
                            onOk: () => {
                                onClickRequest({
                                    props,
                                    data,
                                    refs,
                                    formParams: {},
                                    otp: null,
                                    isSendRequest: data.isSendRequest,
                                    successText: i18n.global.t("views.request.licenseRequest.requestSuccess"),
                                });
                            },
                        });
                    });
                },
            })
        );
    }

    /* ยกเลิกคำขอ */
    if (id && isActive && canCancelRequest && modelRef.isCancelRequest) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.cancelRequest")}`,
                classStyle: `m-1 btn-danger`,
                onClick: () => {
                    data.isSendRequest = true;
                    Promise.resolve()
                        .then(() => (data.isCancelRequest = true))
                        .then(() => {
                            useForm
                                .validate(["isCancelRequest", "cancelRequestRemark"])
                                .then(() => {
                                    if (!modelRef.attachmentCancelRequests?.filter((d) => d.url || d.size)?.length) {
                                        notification["error"]({
                                            message: i18n.global.t("views.request.licenseRequest.requireAttachmentCancelRequest"),
                                        });
                                        return;
                                    }
                                    if (modelRef.refRequestType?.attribute?.isRequireOtp && !modelRef.isOfficerCreate) {
                                        onClickOpenModalOtp({
                                            props,
                                            data,
                                            refs,
                                            ignoreValidate: true,
                                        });
                                    } else {
                                        openModalFormConfirmRequest({
                                            props,
                                            data,
                                            onOk: () => {
                                                onClickRequest({
                                                    props,
                                                    data,
                                                    refs,
                                                    formParams: {},
                                                    otp: null,
                                                    isSendRequest: data.isSendRequest,
                                                    successText: i18n.global.t("views.request.licenseRequest.considerationSuccess"),
                                                    ignoreValidate: true,
                                                });
                                            },
                                        });
                                    }
                                })
                                .catch((error) => {
                                    validateError({ error });
                                    throw error;
                                });
                        });
                },
            })
        );
    }

    if (id && isActive && canApproveCancelRequest) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.approveCancelRequest")}`,
                classStyle: `m-1 btn-danger`,
                onClick: () => {
                    data.isSendRequest = true;
                    openModalFormConfirmRequest({
                        props,
                        data,
                        onOk: () => {
                            const { useForm } = data;
                            const { modelRef } = useForm;
                            modelRef.isApproveCancelRequest = true;
                            onClickRequest({
                                props,
                                data,
                                refs,
                                formParams: {},
                                otp: null,
                                isSendRequest: data.isSendRequest,
                                successText: i18n.global.t("views.request.licenseRequest.considerationSuccess"),
                                ignoreValidate: true,
                            });
                        },
                    });
                },
            })
        );
    }

    if (viewOnly && id && isActive && canArgueLawyer) {
            const statusWaitArgueLawyer = data.statuses.find((status) => status.key === "waitArgueLawyer");
            col2.push(
                createButton({
                    text: `${statusWaitArgueLawyer?.attribute?.actionText}`,
                    classStyle: `m-1 ${statusWaitArgueLawyer?.attribute?.btnClass}`,
                    onClick: () => {
                        data.isSendRequest = true;
                        validate({ props, data, refs }).then(() => {
                            openModalFormConfirmRequest({
                                props: { ...props, modalMessage: i18n.global.t("views.request.licenseRequest.modal.confirmArgueLawyer")},
                                data,
                                onOk: () => {
                                    onClickRequest({
                                        props,
                                        data,
                                        refs,
                                        formParams: {},
                                        otp: null,
                                        isSendRequest: data.isSendRequest,
                                        successText: i18n.global.t("views.request.licenseRequest.sentArgue"),
                                    });
                                },
                            });
                    });
                },
            })
        );
    }

    /* ส่วนของการขออุทธรณ์คำขอ */
    if (viewOnly && id && isActive && canAppealRequest) {
        col2.push(
            createButton({
                text: `${i18n.global.t("button.appealRequest")}`,
                classStyle: `m-1 btn-danger`,
                onClick: () => {
                    data.isSendRequest = true;
                    validate({ props, data, refs }).then(() => {
                        data.useForm.modelRef.isHaveAppealedRequest = true;
                        openModalFormConfirmRequest({
                            okText: i18n.global.t("button.appealRequest"),
                            props: { ...props, modalMessage: i18n.global.t("views.request.licenseRequest.modal.confirmAppeal") },
                            data,
                            onOk: () => {
                                onClickRequest({
                                    props,
                                    data,
                                    refs,
                                    formParams: {},
                                    otp: null,
                                    isSendRequest: data.isSendRequest,
                                    successText: i18n.global.t("views.request.licenseRequest.sentAppeal"),
                                });
                            },
                        });
                    });
                },
            })
        );
    }

    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }),
                    }),
                classStyle: "m-1",
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" }) && data.useForm?.modelRef?.refStatus?.key == "draft") {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix }),
                    }),
                classStyle: "m-1",
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1",
            })
        );
    }

    return (
        <Row type="flex">
            <Col span="11">{col1}</Col>
            <Col span="1">{colCenter}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const userInfo = store.state.resource.auth.info?.user;
    const roleEdit = store.state.resource.auth.info?.roles;
    const promises = [
        callChangeRequestAttachment({}),
        callLicenseRequestStatus({}),
        callRequestType({}),
        callAddressType({}),
        callPreviewVesselRequestAttachment({}),
        createFormAddress({ model: "LicenseRequest" }),
        callNationality({}),
        callReceiverDepartment({}),
        callFishingArea({})
    ];
    return Promise.all(promises).then((arr) => {
        data.licenseRequestAttachment = arr[0];
        data.statuses = arr[1];
        data.licenseTypes = arr[2];
        data.addressTypes = arr[3];
        data.previewVesselRequestAttachment = arr[4];
        data.formAddress = arr[5];
        data.nationalities = arr[6];
        data.recieptDeparments = arr[7];
        data.fishingArea = arr[8];
        data.myRole = roleEdit?.[0]?.refRole;
        data.statusCurrent = data.statuses.find((d) => d.key === modelRef.refStatus?.key);
        /* -- Set Default Value -- */
        if ((!id && !form) || forceDefault) {
            modelRef.isTemp = true;
            modelRef.refRequestType = data.licenseTypes.find((d) => d.key === "changeLicense");
            modelRef.isOfficerCreate = !["PEOPLE", "FISHERMAN"].includes(data.myRole?.name);
            modelRef.refUserCreate = userInfo
            modelRef.refRequesterNationality = data.nationalities.find(d => d.key === "99");
            modelRef.refOwnerNationality = data.nationalities.find(d => d.key === "99");
            modelRef.addresses[0].refAddressType = data.addressTypes?.find(d => d.key === "1");
            // data.licenseRequestAttachment.forEach((item) => {
            //     if (!item.attribute?.objectiveRequest) {
            //         modelRef.attachments.push({
            //             keyAttachment: item.key,
            //             documentName: item.value,
            //             attribute: lodash.cloneDeep(item.attribute),
            //             group: "LicenseRequestAttachment",
            //         });
            //     }
            // });
            modelRef.refVesselRequest.attachmentVesselIdentities.push({ group: "VesselIdentity" })
            modelRef.refVesselRequest.attachmentPositionVesselIdentities.push({ group: "PositionVesselIdentity" })
            modelRef.refVesselRequest.attachmentHeadVessels.push({ group: "HeadVessel" })
            modelRef.refVesselRequest.attachmentFullVessels.push({ group: "FullVessel" })
            if (modelRef.isOfficerCreate) {
                modelRef.refReceiveDept = data.recieptDeparments?.find((dept) => dept.id == userInfo?.refSubDepartment?.id) || data.recieptDeparments?.find((dept) => dept.id == userInfo?.refDepartment?.id);
            }
        }
    });
};

export const initForm = ({ props, data, refs, key }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fieldRequestDetails = createFieldRequestDetail({ props, data, refs, isLoading });
    data.fieldOriginal = createFieldChangeLicense({ props, data, refs, isLoading });
    data.fieldRequester = createFieldRequester({ props, data, key, isLoading });
    // data.fieldRequesterOriginal = createFieldRefOriginalRequester({ props, data, key, isLoading });
    data.fieldOwnerOriginal = createFieldRefOriginalOwner({ props, data, key, isLoading });
    data.fieldChangeRequestLicense = createFieldChangeRequestLicense({ props, data, refs, isLoading });
    data.fieldOfficerConsider = createFieldFisheryOfficerConsider({ props, data, refs, isLoading });
    data.fieldRDConsider = createFieldRDConsider({ props, data, refs, isLoading });
    data.fieldLawyerConsider = createFieldLawyerConsider({ props, data, refs, isLoading });
    data.fieldArgueLawyerConsider = createFieldArgueLawyerConsider({ props, data, refs, isLoading });
    data.fieldDofCenterConsider = createFieldDofCenterConsider({ props, data, refs, isLoading });
    data.fieldDirector = createFieldDirectorConsider({ props, data, refs, isLoading });
    data.fieldAppealRequest = createFieldAppealRequest({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    data.logFishingToolRequests = createLogFishingToolRequests({ props, data, refs });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.addresses.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTop({ props, data, refs }),
        itemsKey: "addresses",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refVesselRequest.attachmentVesselIdentities.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTab1({ props, data, refs }),
        itemsKey: "refVesselRequest.attachmentVesselIdentities",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refVesselRequest.attachmentPositionVesselIdentities.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTab1({ props, data, refs }),
        itemsKey: "refVesselRequest.attachmentPositionVesselIdentities",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refVesselRequest.attachmentHeadVessels.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTab1({ props, data, refs }),
        itemsKey: "refVesselRequest.attachmentHeadVessels",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refVesselRequest.attachmentFullVessels.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTab1({ props, data, refs }),
        itemsKey: "refVesselRequest.attachmentFullVessels",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => ({
            length1: data.useForm.modelRef?.attachments?.filter((d) => d.isDelete !== true)?.length,
        }),
        createRules: () => createRulesTab4({ props, data, refs }),
        itemsKey: "attachments",
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs }),
                },
            });
        }
    });
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) }).then((page) =>
            callSearch({ criteria: createSearchOneCriteriaOriginal({ props, data, refs, id }) }).then((page2) => {
                if (page.data?.[0]?.refOriginal?.id && page2.data?.[0]?.refOriginal.id) {
                    page.data[0].refOriginal = lodash.cloneDeep(page2.data[0].refOriginal);
                }
                return page;
            })
        );
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then((page) => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const onClickOpenModalOtp = ({ props, data, refs, ignoreValidate }) => {
    if (ignoreValidate) {
        openModalOtp({
            props: { dataProp: { form: { mobile: data.useForm.modelRef.refUserCreate.mobile } } },
            onOkCallback: ({ otp, options }) => {
                if (otp.isWaitApprove === true) {
                    otp = null;
                }
                onClickRequest({
                    props,
                    data,
                    refs,
                    otp,
                    formParams: {
                        // refStatus: data.statusWaitAcceptRequest
                    },
                    isSendRequest: data.isSendRequest,
                    ignoreValidate,
                }).then(() => {
                    notification["success"]({ message: i18n.global.t("views.request.licenseRequest.requestSuccess") });
                    options.bind.onCancel();
                    options.bind.visible = false;
                });
            },
        });
    } else {
        if (data.useForm?.modelRef?.fishingToolDeclarations.length > 0 && !data.useForm?.modelRef?.fishingToolDeclarations.map(d => d.isResult).some(Boolean)) {
            notification["error"]({ message: i18n.global.t("error.v1LicenseRequestService.handleProcessRequestLicense.fishingToolDeclaration.null") });
            data.tabKey = "FishingTool"
            scrollToQuerySelector("#fishingToolDeclaration")
            return ;
        }
        data.useForm
            .validate()
            .then(() => {
                openModalOtp({
                    props: { dataProp: { form: { mobile: data.useForm.modelRef.refUserCreate.mobile } } },
                    onOkCallback: ({ otp, options }) => {
                        if (otp.isWaitApprove === true) {
                            otp = null;
                        }
                        onClickRequest({
                            props,
                            data,
                            refs,
                            otp,
                            formParams: {
                                // refStatus: data.statusWaitAcceptRequest
                            },
                            isSendRequest: data.isSendRequest,
                        }).then(() => {
                            notification["success"]({ message: i18n.global.t("views.request.licenseRequest.requestSuccess") });
                            options.bind.onCancel();
                            options.bind.visible = false;
                        });
                    },
                });
            })
            .catch((error) => {
                validateError({ error });
                throw error;
            });
    }
};
